import { render, staticRenderFns } from "./RetentionSection.vue?vue&type=template&id=662b6cc2&scoped=true&"
import script from "./RetentionSection.vue?vue&type=script&lang=js&"
export * from "./RetentionSection.vue?vue&type=script&lang=js&"
import style0 from "./RetentionSection.vue?vue&type=style&index=0&id=662b6cc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662b6cc2",
  null
  
)

export default component.exports